import React from 'react'
import './Header.css'

const Header = ({title, image}) => {
  return (
    <div className="header-image-container">
      <img src={image} alt="Header" className="header-image" />
      <div className="header-overlay" />
      <div className="header-text">
        <h1>{title}</h1>
      </div>
    </div>
  )
}

export default Header
